const EXPRESS_DELIVERY_AVAILABLE_BEFORE_HOUR = 15
const START_NIGHT_HOUR = 20
const END_NIGHT_HOUR = 8

export default {
  getTimeInTimezone (timezone = 'Europe/Kiev') {
    return new Date(Date().toString({ timeZone: timezone }))
  },
  isAvailableTodayExpressDelivery () {
    return this.getTimeInTimezone().getHours() < EXPRESS_DELIVERY_AVAILABLE_BEFORE_HOUR
  },
  isNightTime () {
    return this.getTimeInTimezone().getTime() > START_NIGHT_HOUR || this.getTimeInTimezone().getTime() < END_NIGHT_HOUR
  }
}
